import { Button, Text, ThemeIcon, Title, rem } from "@mantine/core";
import { closeModal, openContextModal } from "@mantine/modals";
import IconUserShare from "@src/assets/icons/tabler/user-share.svg?react";
import type { WhiteboardDocumentId } from "@src/components/collaboration/document-id";
import { openSharingModal } from "@src/components/share-whiteboard-panel/share-modal-fns";

let modalId: string | null = null;

export function openArchiveBlockedModal(whiteboardId: WhiteboardDocumentId) {
	modalId = openContextModal({
		modal: "buttonsModal",
		radius: "md",
		size: "lg",
		padding: rem(20),
		centered: true,
		withCloseButton: false,
		zIndex: 9999,
		onClose: () => {
			modalId = null;
		},
		innerProps: {
			children: <ArchiveBlockedModalContent whiteboardId={whiteboardId} />,
		},
	});
}

export function closeArchiveBlockedModal() {
	if (modalId) {
		closeModal(modalId);
	}
}

interface ArchiveBlockedModalContentProps {
	whiteboardId: WhiteboardDocumentId;
}

function ArchiveBlockedModalContent({
	whiteboardId,
}: ArchiveBlockedModalContentProps) {
	const handleActionConfirm = () => {
		closeArchiveBlockedModal();
		openSharingModal(whiteboardId);
	};

	const handleActionCancel = () => {
		closeArchiveBlockedModal();
	};

	return (
		<div className="flex flex-col items-center p-2 mt-2">
			<ThemeIcon
				variant="filled"
				className="w-16 h-16 rounded-full bg-brand-primary-soft text-brand-primary"
			>
				<IconUserShare className="w-[60%] h-[60%]" />
			</ThemeIcon>
			<Title className="mt-4 text-center" order={3}>
				Delete blocked
			</Title>
			<Text
				className="my-4 w-full text-center break-words text-balance text-text-tertiary"
				size="lg"
			>
				This whiteboard is shared or published. Remove collaborators or
				unpublish it before deleting.
			</Text>
			<div className="flex mt-2 space-x-4 w-full">
				<Button
					variant="outline"
					size="md"
					radius="md"
					onClick={handleActionCancel}
					className="flex-grow w-full text-text-primary hover:text-brand-primary bg-surface-default border-border-default hover:bg-surface-hover-subtle"
				>
					Cancel
				</Button>
				<Button
					variant="cta"
					size="md"
					radius="md"
					onClick={handleActionConfirm}
					className="flex-grow w-full"
				>
					Permission Settings
				</Button>
			</div>
		</div>
	);
}
